export default "__VITE_ASSET__BhFdLqJH__"